"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corno-giovine": {
    "847e9b90": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "belgrado": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "592c1e44": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "bianca-vidore": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4f45d87": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "buon-pensiero": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb50ff39": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "ca-rossa": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a6dfac47": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "campagna": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac90ece6": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "campagnetta": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42a7b168": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "castelletto": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36d25250": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "colombarone": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de979cd2": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "cooperativa-vecchio-po": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "885ff995": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf45caaf": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "inomata": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9a5a3f4": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "mezzano-nuovo": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6bb939c3": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "mezzano-squadre": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b384ea7": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "mezzano-vecchio": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e245332": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "mulino-di-sopra": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a0decfd": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "quartierone": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4a404c4": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "san-roco": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9374489": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "temesvar": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41300669": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "skipSearch": false
    }],
    "verani": [{
      "hkey": "2fee45c4",
      "slug": "corno-giovine",
      "name": "Corno Giovine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;